export default __webpack_public_path__ + "static/media/amit.0eed880d.png";